import dayStartTime from './dayStartTime'
import totalDayMinutes from './totalDayMinutes'
import normalize from './normalize'

export default ({ value, width }) =>
  (normalize(value).diff(dayStartTime, 'minutes') / totalDayMinutes) * width
